import { useCallback } from 'react';

// Create a singleton state manager for last viewed rooms per directory
class LastViewedRoomManager {
  constructor() {
    this.lastViewed = {
      conversations: null,
      channels: null,
      contacts: null,
    };
  }

  getLastViewed(directory) {
    const result = this.lastViewed[directory] || null;
    return result;
  }

  setLastViewed(directory, roomId) {
    this.lastViewed[directory] = roomId;
  }

  clearLastViewed(directory) {
    this.lastViewed[directory] = null;
  }

  // Debug method to see all states
  getAllLastViewed() {
    return { ...this.lastViewed };
  }
}

// Singleton instance
const lastViewedManager = new LastViewedRoomManager();

/**
 * Hook for managing the last viewed room per directory type
 * Tracks which room was last viewed in conversations, channels, contacts
 * @param {string} directory - Directory type ('conversations', 'channels', 'contacts')
 * @returns {object} State management functions
 */
export const useLastViewedRoom = (directory) => {
  const getLastViewed = useCallback(() => {
    const result = lastViewedManager.getLastViewed(directory);
    return result;
  }, [directory]);

  const setLastViewed = useCallback((roomId) => {
    lastViewedManager.setLastViewed(directory, roomId);
  }, [directory]);

  const clearLastViewed = useCallback(() => {
    lastViewedManager.clearLastViewed(directory);
  }, [directory]);

  return {
    getLastViewed,
    setLastViewed,
    clearLastViewed,
  };
};

// Export the singleton manager for direct access if needed
export { lastViewedManager };

export default useLastViewedRoom;